// Library imports
import { createContext, useContext, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

// Local imports
import { SetPasswordModal } from '@/components/Shared/MediaKitModals/SetPasswordModal';
import { getMediaKitInfoAPIFn } from '@/redux/features/CurrentUser/currentUserSlice';
import { saveMediaKitInfoAPIFn } from '@/redux/features/MediaKit/mediakitSlice';
import { saveMediaKitDraftPayload, useKitStates } from '@/utils';

const PasswordGateContext = createContext({
  requirePassword: action => action()
});

export const usePasswordGate = () => useContext(PasswordGateContext);

export const PasswordGateProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { isSavedPassword, userId, mediaKitId, mkData } = useKitStates();
  const [isOpen, setIsOpen] = useState(false);
  const pendingActionRef = useRef(null);

  const requirePassword = action => {
    if (isSavedPassword) {
      action();
      return;
    }
    pendingActionRef.current = action;
    setIsOpen(true);
  };

  const onSavePasswordUpdateKit = async () => {
    const payload = saveMediaKitDraftPayload({
      mediaKitData: { isSavedPassword: true },
      persistedMediaKitData: mkData,
      mediaKitId
    });

    await dispatch(saveMediaKitInfoAPIFn({ userId, data: payload }));
    await dispatch(getMediaKitInfoAPIFn({ userId }));

    const pending = pendingActionRef.current;
    pendingActionRef.current = null;
    pending?.();
  };

  return (
    <PasswordGateContext.Provider value={{ requirePassword }}>
      {children}

      <SetPasswordModal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        setSampleKitToProfKit={() => {}}
        onSavePasswordUpdateKit={onSavePasswordUpdateKit}
      />
    </PasswordGateContext.Provider>
  );
};
